// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__1-7j8","mob":"style_mob__LHona","logo":"style_logo__1Kf02"};